import React from "react";
import { classNames } from "./classNames";
import { Text } from "./Text";

type TwoTeamScoreBoardProps = {
  homeContent: React.ReactNode;
  awayContent: React.ReactNode;
  homeAccentColor?: string;
  awayAccentColor?: string;
  width?: string;
  scoreHeight?: string;
  accentHeight?: string;
  gap?: string;
  columnGap?: string;
  className?: string;
  style?: React.CSSProperties;
  columnClassName?: string;
  homeColumnClassName?: string;
  awayColumnClassName?: string;
  homeAccentClassName?: string;
  awayAccentClassName?: string;
  homeScoreClassName?: string;
  awayScoreClassName?: string;
  homeAccentStyle?: React.CSSProperties;
  awayAccentStyle?: React.CSSProperties;
  homeScoreStyle?: React.CSSProperties;
  awayScoreStyle?: React.CSSProperties;
};

const DEFAULT_WIDTH = "14vw";
const DEFAULT_SCORE_HEIGHT = "6vw";
const DEFAULT_ACCENT_HEIGHT = "1vw";
const DEFAULT_GAP = "0.2vw";
const DEFAULT_COLUMN_GAP = "0.2vw";

export const TwoTeamScoreBoard = ({
  homeContent,
  awayContent,
  homeAccentColor,
  awayAccentColor,
  width = DEFAULT_WIDTH,
  scoreHeight = DEFAULT_SCORE_HEIGHT,
  accentHeight = DEFAULT_ACCENT_HEIGHT,
  gap = DEFAULT_GAP,
  columnGap = DEFAULT_COLUMN_GAP,
  className,
  style,
  columnClassName,
  homeColumnClassName,
  awayColumnClassName,
  homeAccentClassName,
  awayAccentClassName,
  homeScoreClassName,
  awayScoreClassName,
  homeAccentStyle,
  awayAccentStyle,
  homeScoreStyle,
  awayScoreStyle,
}: TwoTeamScoreBoardProps) => (
  <div
    className={classNames("flex", className)}
    style={{ width, gap, ...style }}
  >
    <div
      className={classNames(
        "relative flex flex-1 flex-col items-center justify-center text-black",
        columnClassName,
        homeColumnClassName
      )}
      style={{ gap: columnGap }}
    >
      <div
        className={classNames("w-full", homeAccentClassName)}
        style={{
          height: accentHeight,
          background: homeAccentColor,
          ...homeAccentStyle,
        }}
      />
      <div
        className={classNames(
          "flex w-full items-center justify-center bg-white font-bold",
          homeScoreClassName
        )}
        style={{ height: scoreHeight, ...homeScoreStyle }}
      >
        <Text variant="scoreboardText">{homeContent}</Text>
      </div>
    </div>

    <div
      className={classNames(
        "relative flex flex-1 flex-col items-center justify-center text-black",
        columnClassName,
        awayColumnClassName
      )}
      style={{ gap: columnGap }}
    >
      <div
        className={classNames("w-full", awayAccentClassName)}
        style={{
          height: accentHeight,
          background: awayAccentColor,
          ...awayAccentStyle,
        }}
      />
      <div
        className={classNames(
          "flex w-full items-center justify-center bg-white font-bold",
          awayScoreClassName
        )}
        style={{ height: scoreHeight, ...awayScoreStyle }}
      >
        <Text variant="scoreboardText">{awayContent}</Text>
      </div>
    </div>
  </div>
);
